import { render, staticRenderFns } from "./WelcomeStep.vue?vue&type=template&id=2f8baa40&scoped=true&"
import script from "./WelcomeStep.vue?vue&type=script&lang=js&"
export * from "./WelcomeStep.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeStep.vue?vue&type=style&index=0&id=2f8baa40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8baa40",
  null
  
)

export default component.exports